
import { mapGetters } from "vuex";
import orderDetailsItemDetailsRow from "../reciever/order-details-item-details-row.vue";
export default {
  components: { orderDetailsItemDetailsRow },

  props: {
    items: { type: Array, default: () => [] },
    newOrderDetails: {
      type: Object,
      default: () => {}
    },
    readyForDeliveryDialog: {
      type: Boolean,
      default: false
    },
    isNewOrderDialog: {
      type: Boolean,
      default: false
    },
    cancelledOrderDetails: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      combos: []
    };
  },
  watch: {
    items: {
      handler() {
        this.combos = this.getCombosFromItemsList(this.items);
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapGetters("restaurant", ["getRestaurantFeatures"]),
    isAvailabilityToggleShown() {
      return (
        this.getRestaurantFeatures(this.newOrderDetails.restaurant_id)
          ?.order_modification &&
        this.newOrderDetails?.source === this.$constants.Channels.SWIGGY.name &&
        this.isNewOrderDialog
      );
    }
  }
};
